import { Industry } from 'signup-ui-lego-core/constants/Industry';
import { Step } from '../views/Step';
import { MessageKey } from './MessageKey';
import { Platform } from './Platform';
export const StepByIndustry = new Map([[Industry.RealEstate, {
  [Platform.Mobile]: new Map([[Step.JobRole, MessageKey.PersonWithBox], [Step.CompanyName, MessageKey.WhiteHouse], [Step.CompanyDomain, MessageKey.Hands]]),
  [Platform.Desktop]: new Map([[Step.JobRole, MessageKey.PersonWithBox], [Step.CompanyName, MessageKey.WhiteHouse], [Step.CompanyDomain, MessageKey.Hands]])
}]]);